<template>
    <div id="groups">
        <vs-popup fullscreen title="Add/Edit Group" :active.sync="activePrompt">
            <div class="con-exemple-prompt">
                <vs-input placeholder="Arabic Name" v-model="group.ar_name" />
                <vs-input placeholder="English Name" v-model="group.en_name" />
                <vSelect :filterable="false" :multiple="true" v-model="group.items" @search="search"
                    :options="$store.state.movies.search" placeholder="select movies">

                    <template slot="option" slot-scope="option">
                        <div class="d-center">
                            <img :src="`${option.poster}`" />
                            {{ option.en_title }} - {{ option.year }}
                        </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                            <img :src="`${option.poster}`" />
                            {{ option.en_title }}
                        </div>
                    </template>
                </vSelect>
                <div style="height:350px;overflow-x:scroll">
                    <vs-row vs-w="12" class="p-3">
                        <vs-col v-for="(movie, index) in group.items" :key="index" vs-w="6" vs-type="flex" vs-align="center">
                            <td>
                                <img :src="`${movie.poster}`" />
                            </td>
                            <td>
                                {{ movie.en_title }} - {{ movie.year }}
                            </td>
                            <td>
                                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                    class="ml-2" @click="group.items.splice(index, 1)" />
                            </td>
                        </vs-col>
                    </vs-row>
                </div>
                <br>
                <vs-button color="primary" type="border" @click="acceptAlert">save</vs-button>
            </div>
        </vs-popup>
        <vs-table v-if="groups.length !=0" :data="groups.data">
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <div class="flex flex-wrap-reverse items-center">
                    <vs-button color="primary" type="border" @click="activePrompt = true; group = def_group">
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" /> Add New group</vs-button>
                </div>
            </div>
            <template #thead>
                <vs-th>Arabic name</vs-th>
                <vs-th>English name</vs-th>
                <vs-th>Ramadan</vs-th>
                <vs-th>Movies</vs-th>
                <vs-th>Series</vs-th>
                <vs-th>Actions</vs-th>
            </template>
            <template slot-scope="{data}">
                <draggable tag="tbody" v-model="groups.data" group="people" @end="updateSequence" style="width:100%">
                    <vs-tr v-for="(group, index) in data" :key="index">
                        <vs-td>{{ group.ar_name }}</vs-td>
                        <vs-td>{{ group.en_name }}</vs-td>
                        <vs-td>
                            <span v-if="group.ramadan == 1">yes</span>
                            <span v-if="group.ramadan == 0">no</span>
                        </vs-td>
                        <vs-td>{{ group.movies }}</vs-td>
                        <vs-td>{{ group.series }}</vs-td>
                        <vs-td class="whitespace-no-wrap">
                            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                @click="edit(group)" />
                            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                class="ml-2" @click="openConfirm(group)" />
                        </vs-td>
                    </vs-tr>
                </draggable>

            </template>
        </vs-table>
    </div>
</template>
<script>
import vSelect from 'vue-select'
import draggable from "vuedraggable";
import 'vue-select/dist/vue-select.css';
export default {
    components: {
        vSelect, draggable
    },
    data() {
        return {
            select1: 2,
            activePrompt: false,
            delConfirm: false,
            val: '',
            groups: [],
            movies: [],
            def_group: {
                id: 0,
                ar_name: '',
                en_name: '',
                items: []
            },
            group: {
                id: 0,
                ar_name: '',
                en_name: '',
                items: []
            }
        }
    },
    created() {
        this.fetchGroups()
        
    },
    methods: {
        fetchGroups(){
            this.$vs.loading('#groups');
            this.axios.get(`${this.$apiUrl}/groups`).then(res => {
                this.$vs.loading.close();
					this.groups=res.data
			 });
        },
        updateSequence() {
            var ids = [];
            for (let index = 0; index < this.groups.data.length; index++) {
                const element = this.groups.data[index];
                
                ids.push(element.id);
            }
            this.$store.dispatch("groups/updateSequence", {
                data: ids,
            });
        },
        search(query, loading) {
            this.$store.dispatch('movies/search', query)
        },
        openConfirm(group) {
            this.group = group;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Delete group`,
                text: 'Are you sure to delete this item ?',
                accept: this.del,
                close: this.close
            })
        },
        acceptAlert(color) {
            const data = new FormData();
            data.append('id', this.group.id);
            data.append('ar_name', this.group.ar_name);
            data.append('en_name', this.group.en_name);
            this.group.items.forEach(element => {
                data.append('items[]', element.id);
            });

            this.axios.post(`${this.$apiUrl}/groups`, data).then(res => {
                this.group = this.def_group;
                if (res.status == 200) {
                    this.$vs.notify({
                        color: 'success',
                        title: 'group Addedd',
                        text: res.data.response.en_name
                    })
                }
               this.fetchGroups()
                this.group = this.def_group;
                this.activePrompt = false
            })

        },
        close() {
            this.group = this.def_group;
        },
        edit(group) {
            this.group = group;
            this.activePrompt = true;
        },
        del() {
            this.axios.post(`${this.$apiUrl}/groups/delete/${this.group.id}`).then(res => {
                this.group = this.def_group;
                if (res.status == 200) {
                    this.$vs.notify({
                        color: 'warning',
                        title: 'group Deleted !',
                        text: res.data.response.en_name
                    })
                }
                this.fetchGroups()
            })

        },
    }
}
</script>
<style lang="scss" scoped>
.con-exemple-prompt {
    padding: 10px;
    padding-bottom: 0px;

    .vs-input {
        width: 100%;
        margin-top: 10px;
    }

    .v-select {
        width: 100%;
        margin-top: 10px;
    }

}

img {
    height: auto;
    max-width: 2.5rem;
    margin-right: 1rem;
}

.d-center {
    display: flex;
    align-items: center;
}

.selected img {
    width: auto;
    max-height: 23px;
    margin-right: 0.5rem;
}
</style>